class DebugModel {
    public currentDebugCase: string;
    public debugData: any;
    public special: boolean
    public fakeResponse: any;
    public fakeJackpot: { name: string, amount: number };

    public cleanUp() {
        this.currentDebugCase = "";
        this.debugData = null;
        this.special = false;
        this.fakeJackpot = null;
    }
}

export default new DebugModel();
